import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import MainTrackPage from "../-components/MainTrackPage";

const searchSchema = z.object({
  publish: z.coerce.string().optional(),
});

export const Route = createFileRoute("/audiolab/tracks/$TRACK_ID/")({
  component: RouteComponent,
  validateSearch: searchSchema,
  head: () => ({ meta: [{ title: "Track | Audiolab | Lutely" }] }),
});

function RouteComponent() {
  return <MainTrackPage />;
}
